export const isDevelopment = import.meta.env.MODE === "development";

export const AppEndpoints = {
  coreApiUrl: "/api",
  atsApiUrl: "/ats/api",
  hrApiUrl: "/hr/api",
  payrollApiUrl: "/payroll/api",
  avaApiUrl: "/ava/api",
};
